import { shuffle } from './rng.js';
export const SUITS = ['S', 'H', 'D', 'C'];
export const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
export const SUIT_NAMES = {
    S: 'Spades',
    H: 'Hearts',
    D: 'Diamonds',
    C: 'Clubs',
};
export const SUIT_SYMBOLS = {
    S: '♠',
    H: '♥',
    D: '♦',
    C: '♣',
};
export const RANK_NAMES = {
    A: 'Ace',
    '2': 'Two',
    '3': 'Three',
    '4': 'Four',
    '5': 'Five',
    '6': 'Six',
    '7': 'Seven',
    '8': 'Eight',
    '9': 'Nine',
    '10': 'Ten',
    J: 'Jack',
    Q: 'Queen',
    K: 'King',
};
export function isRed(suit) {
    return suit === 'H' || suit === 'D';
}
export function isBlack(suit) {
    return suit === 'S' || suit === 'C';
}
/** "Ace of Spades" — used for screen readers and the event log. */
export function cardName(card) {
    return `${RANK_NAMES[card.rank]} of ${SUIT_NAMES[card.suit]}`;
}
/** "A♠" — used for compact UI labels. */
export function cardLabel(card) {
    return `${card.rank}${SUIT_SYMBOLS[card.suit]}`;
}
/**
 * Penalty scoring: how much a card is worth to be caught holding. Also doubles
 * as the bot's "get rid of the expensive stuff first" ordering.
 */
export function cardPenaltyValue(card) {
    switch (card.rank) {
        case 'A':
            return 11;
        case 'K':
        case 'Q':
        case 'J':
            return 10;
        default:
            return Number(card.rank);
    }
}
/** Build `deckCount` standard 52-card decks, unshuffled. */
export function buildDeck(deckCount = 1) {
    const cards = [];
    for (let d = 0; d < deckCount; d++) {
        for (const suit of SUITS) {
            for (const rank of RANKS) {
                cards.push({ id: `${rank}${suit}#${d}`, suit, rank });
            }
        }
    }
    return cards;
}
export function buildShuffledDeck(deckCount, rngState) {
    const result = shuffle(buildDeck(deckCount), rngState);
    return { cards: result.items, rngState: result.state };
}
/** Stable display order: group by suit, then by rank. */
export function sortHand(hand) {
    return hand.slice().sort((a, b) => {
        if (a.suit !== b.suit)
            return SUITS.indexOf(a.suit) - SUITS.indexOf(b.suit);
        return RANKS.indexOf(a.rank) - RANKS.indexOf(b.rank);
    });
}
//# sourceMappingURL=cards.js.map